import { useQuery } from "@tanstack/react-query";
import { EditRoomApi, EditRoomFolder, Folder, FolderApi } from "certiblok-api-manager";
import { instanceApi } from "../../../../../utils/hooks/api";

export const getUseEditCreateFolderFormKey = (folderId?: string, parentFolderId?: string, isEditRoom?: boolean) => [
	"editCreateInitFolder",
	folderId,
	parentFolderId,
	isEditRoom,
];

export const useFetchFolderData = ({
	folder,
	parentFolderId: _parentFolderId,
	isEditRoom,
}: {
	folder?: Folder;
	parentFolderId?: string;
	isEditRoom?: boolean;
}) => {
	const { data, isLoading } = useQuery({
		queryKey: getUseEditCreateFolderFormKey(folder?.id, _parentFolderId, isEditRoom),
		queryFn: async () => {
			let folderData: Folder | null = null;
			if (folder) {
				folderData = (await instanceApi(FolderApi).getPlainFolder(folder.id)).data;
			}
			let parentFolder: Folder | EditRoomFolder | null = null;
			const parentFolderId = folder?.parentFolderId ?? _parentFolderId;
			if (parentFolderId) {
				parentFolder = isEditRoom
					? (await instanceApi(EditRoomApi).getPlainEditRoomFolder(parentFolderId ?? "")).data
					: (await instanceApi(FolderApi).getPlainFolder(parentFolderId ?? "")).data;
			}
			return { folderData, parentFolder };
		},
		cacheTime: 0,
		staleTime: 0,
	});

	return {
		data,
		isLoading,
	};
};
